import GET_COMPONENTS_LAYOUT from './queries/GET_COMPONENTS_LAYOUT';
import GET_FILTERS from './queries/GET_FILTERS';
import GET_STORE from './queries/GET_STORE';
import IS_LOGIN from './queries/IS_LOGIN';

export default (cache) => {
  cache.writeQuery({
    query: IS_LOGIN,
    data: {
      isLoggedIn: !!localStorage.getItem('token'),
    },
  });

  cache.writeQuery({
    query: GET_STORE,
    data: {
      isFilterbarVisible: false,
      isAttachmentVisible: true,
    },
  });

  cache.writeQuery({
    query: GET_FILTERS,
    data: {
      filters: {
        __typename: 'filters',
        models: {
          __typename: 'modelFilters',
          Authors: [],
          CreationDate: [],
          ModelCategories: [],
          search: '',
          SharedTo: [],
        },
        projects: {
          __typename: 'projectFilters',
          Authors: [],
          CreationDate: [],
        },
      },
    },
  });

  cache.writeQuery({
    query: GET_COMPONENTS_LAYOUT,
    data: {
      componentsLayout: 'list',
    },
  });
};
